import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { fetchProfileTokenizado, updateCaracteristicas } from '../api/perfilTokenizado';
import PerfilCards from '../components/PerfilCards';
import AmbitoCards from '../components/AmbitoCards';
import CaracteristicasCards from '../components/CaracteristicasCards';
import { ArrowLeft } from "lucide-react";

const PerfilTokenizadoPage = () => {
  const { t } = useTranslation('perfil_funcional'); // Namespace específico
  const [data, setData] = useState(null);
  const [selectedPerfil, setSelectedPerfil] = useState(null);
  const [selectedAmbito, setSelectedAmbito] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const navigate = useNavigate();

  const cargarDatos = async () => {
    try {
      const result = await fetchProfileTokenizado();
      setData(result);
    } catch (err) {
      console.error("❌ Error al cargar el perfil:", err);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);

  const toggleCaracteristica = async (id) => {
    const nuevoData = JSON.parse(JSON.stringify(data));
    let nuevaCaracteristica = null;
    let nuevoAmbitoSeleccionado = null;

    for (const perfil of nuevoData.perfiles) {
      for (const ambito of perfil.ambitos) {
        for (const c of ambito.caracteristicas) {
          if (c.id === id) {
            const nuevoEstado = c.estado === "necesita ayuda" ? "no necesita ayuda" : "necesita ayuda";
            c.estado = nuevoEstado;
            nuevaCaracteristica = { id: c.id, estado: nuevoEstado };

            if (selectedAmbito && ambito.nombre === selectedAmbito.nombre) {
              nuevoAmbitoSeleccionado = ambito;
            }
          }
        }
      }
    }

    setData(nuevoData);
    if (nuevoAmbitoSeleccionado) {
      setSelectedAmbito(nuevoAmbitoSeleccionado);
    }

    if (nuevaCaracteristica) {
      setIsUpdating(true);
      try {
        await updateCaracteristicas([nuevaCaracteristica]);
        console.log("✅ Característica guardada:", nuevaCaracteristica);
      } catch (err) {
        console.error("❌ Error al guardar:", err);
        alert(t("save_error"));
        cargarDatos();
      } finally {
        setIsUpdating(false);
      }
    }
  };

  if (!data) {
    return (
      <div className="flex items-center justify-center min-h-screen text-gray-500 text-lg">
        ⏳ {t("loading")}
      </div>
    );
  }

  if (selectedAmbito) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-6">
        <CaracteristicasCards
          caracteristicas={selectedAmbito.caracteristicas}
          onToggle={toggleCaracteristica}
          onBack={() => setSelectedAmbito(null)}
          t={t}
        />
        {isUpdating && (
          <div className="mt-4 text-sm text-blue-500 animate-pulse">
            🔄 {t("saving")}
          </div>
        )}
      </div>
    );
  }

  if (selectedPerfil) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-6">
        <AmbitoCards
          ambitos={selectedPerfil.ambitos}
          onSelect={(ambito) => {
            const perfilActualizado = data.perfiles.find(p => p.nombre === selectedPerfil.nombre);
            const ambitoActualizado = perfilActualizado.ambitos.find(a => a.nombre === ambito.nombre);
            setSelectedAmbito(ambitoActualizado);
          }}
          onBack={() => setSelectedPerfil(null)}
          t={t}
        />
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-6 mt-5">
        <div className="flex flex-row items-center justify-between flex-wrap gap-4 mb-6">
          <h2 className="text-2xl font-bold text-[#247BA8] justify-left flex-1">
            {t("subtitle")}
          </h2>

          <button
            onClick={() => navigate("/recursos")}
            className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#247BA8] text-white shadow-sm transition hover:bg-[#1B6388] hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#247BA8]/30 focus-visible:ring-offset-2"
          >
            <ArrowLeft size={20} />
          </button>
        </div>

      <PerfilCards perfiles={data.perfiles} onSelect={setSelectedPerfil} t={t} />
    </div>
  );
};

export default PerfilTokenizadoPage;
